import { Canvas } from '@react-three/fiber'
import { OrbitControls, PerspectiveCamera, Center, Bounds } from '@react-three/drei'
import { useViewerStore } from '@/store/viewer-store'
import { ContainerModel } from './container-model'
import { LoadingScreen } from './loading-screen'

export const Viewer3D = () => {
  const isLoading = useViewerStore((state) => state.isLoading)
  const error = useViewerStore((state) => state.error)
  const cameraPosition = useViewerStore((state) => state.cameraPosition)

  return (
    <>
      <LoadingScreen isLoading={isLoading} />
      <div
        id="viewer-3d-container"
        data-testid="viewer-3d-container"
        style={{
          position: 'fixed',
          top: '10px',
          left: '10px',
          right: '10px',
          bottom: '10px',
          width: 'calc(100vw - 20px)',
          height: 'calc(100vh - 20px)',
        }}
      >
        {error && (
          <div
            data-testid="viewer-3d-error"
            style={{
              position: 'absolute',
              top: 20,
              left: 20,
              right: 20,
              padding: '1rem',
              backgroundColor: '#ff4444',
              color: 'white',
              borderRadius: '4px',
              zIndex: 10,
            }}
          >
            Error: {error}
          </div>
        )}

        <div data-testid="viewer-3d-canvas" style={{ width: '100%', height: '100%' }}>
          <Canvas>
            <PerspectiveCamera
              makeDefault
              position={[cameraPosition.x, cameraPosition.y, cameraPosition.z]}
              fov={75}
            />
            {/* Increased ambient light intensity from 0.5 to 1.5 */}
            <ambientLight intensity={1.5} />
            {/* Increased directional light intensity from 1 to 2 */}
            <directionalLight position={[10, 10, 5]} intensity={2} />
            {/* Add additional lights for better reflection */}
            <directionalLight position={[-10, -10, -5]} intensity={1.5} />
            <directionalLight position={[0, 10, -10]} intensity={1.5} />
            <Bounds fit clip observe margin={1.2}>
              <Center>
                <ContainerModel modelPath={`${window.location.origin}/TexturesENG-new.glb?v=${Date.now()}`} />
              </Center>
            </Bounds>
            <OrbitControls enableZoom={true} enablePan={true} />
          </Canvas>
        </div>
      </div>
    </>
  )
}
